import { h, defineComponent } from 'vue';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { Icon } from '@/ui/components/icon/Icon';
import { saveAs } from 'file-saver';
import { isPdf } from '@/ui/helpers/systemHelper';
import { t } from '@/ui/i18n/i18n';

export const DocumentAsset = defineComponent<ItemProps>({
  name: 'DocumentAsset',
  props: ['item'],
  setup({ item }) {
    const hasFile = item.assets?.documents?.length
      || item.assets?.images?.length
      || item.assets?.videos?.length
      || item.assets?.audios?.length;

    const file = hasFile ? Object.values(item.assets || []).find(files => files.length > 0)[0] : null;

    const link = `${process.env.VUE_APP_ASSETS_SERVICE_URL}/document/${file && file.id}`;

    const onSaveClick = () => {
      saveAs(link, file.fileName);
    };

    return function render() {
      return hasFile ? h('div', {
        class: 'inspection-report__question-file',
        on: { click: onSaveClick },
      }, [
        h(Icon, {
          props: { icon: 'paperclip' },
        }),
        h('a', { attrs: { href: isPdf ? link : '#' } }, t('inspection-report.attached-file', { name: file.fileName })),
      ]) : null;
    };
  },
});
